const isProd = process.env.NODE_ENV === 'production';

const logger = {
  // `log` mirrors `info`; the ported intake PDF generator calls logger.log.
  log: (...args) => { if (!isProd) console.log(...args); },
  info: (...args) => { if (!isProd) console.log(...args); },
  warn: (...args) => { if (!isProd) console.warn(...args); },
  error: (...args) => { if (!isProd) console.error(...args); },
};

export default logger;
